import React from "react";
import { useDroppable } from "@dnd-kit/core";
import CfcRegistration from "./CfcRegistration";

export default function CfcCycleUser({ cfcCycleUser, cfcWod, cfcCycle, cfcCycleRegistrationIds, onClickOnDelete, onClickOnMoveLeft, onClickOnMoveRight }) {
  const { isOver, setNodeRef } = useDroppable({
    id: cfcCycleUser.custom_id || cfcCycleUser.id,
    data: {
      cfcWod,
      cfcCycle,
      accepts: cfcCycleRegistrationIds,
      position: cfcCycleUser.position
    }
  });

  const dropStyles = {
    backgroundColor: isOver ? "var(--success-ultra-light-color)" : "var(--grey-200)",
    border: isOver ? "2px dotted var(--success-color)" : "2px dotted var(--grey-400)",
    borderRadius: "4px",
    padding: "5px"
  };

  return (
    <div style={dropStyles}>
      <div ref={setNodeRef} style={{ minHeight: "100px", width: "100%" }}>
        <CfcRegistration cfcRegistration={cfcCycleUser.cfc_registration} cfcCycleUser={cfcCycleUser} onClickOnDelete={onClickOnDelete} onClickOnMoveLeft={onClickOnMoveLeft} onClickOnMoveRight={onClickOnMoveRight} cfcCycle={cfcCycle}></CfcRegistration>
      </div>
    </div>
  );
}
